export enum EnumSituacaoNotaFiscal{
    Pendente = 0,
    Autorizada = 1,
    Cancelada = 2
}